import { Description, Link, DataUsage, BlurLinear } from "@material-ui/icons"
import React from "react"

const JsonCopyButtons: React.FC<{
  onCopyValue: () => void
  onCopyPath: () => void
  onCopyFormatted: () => void
  onCopyFormattedMultiArray: () => void
  classes: any
}> = ({
  onCopyValue,
  onCopyPath,
  onCopyFormatted,
  onCopyFormattedMultiArray,
  classes
}) => {
  return (
    <span className={classes.copyButtons}>
      <button
        onClick={e => {
          e.stopPropagation()
          onCopyValue()
        }}
        className={`${classes.iconButton} ${classes.valueButton}`}
        title="Copy Value"
      >
        <Description />
      </button>
      <button
        onClick={e => {
          e.stopPropagation()
          onCopyPath()
        }}
        className={`${classes.iconButton} ${classes.pathButton}`}
        title="Copy Path"
      >
        <Link />
      </button>
      <button
        onClick={e => {
          e.stopPropagation()
          onCopyFormatted()
        }}
        className={`${classes.iconButton} ${classes.formattedButton}`}
        title="Copy Formatted"
      >
        <DataUsage />
      </button>
      <button
        onClick={e => {
          e.stopPropagation()
          onCopyFormattedMultiArray()
        }}
        className={`${classes.iconButton} ${classes.formattedButton}`}
        title="Copy Formatted Multi Array"
      >
        <BlurLinear />
      </button>
    </span>
  )
}
export default JsonCopyButtons
